/** Reusable line indicator — shows current position out of total with a light backdrop. Click a line to jump to it. */
export default function DotIndicator({ total, index, onSelect }) {
  if (total <= 1) return null;

  return (
    <div className="absolute bottom-[-8px] left-5 right-5 h-[30px] flex items-center justify-center" onClick={(e) => e.stopPropagation()} onPointerDown={(e) => e.stopPropagation()} onPointerUp={(e) => e.stopPropagation()}>
      <div className="flex w-full max-w-xs items-center gap-1 rounded-full bg-neutral-400/20 backdrop-blur-sm px-[1px] py-[1px]">
        {Array.from({ length: total }).map((_, idx) => (
          <button
            key={idx}
            onClick={(e) => { e.stopPropagation(); onSelect?.(idx); }}
            className={`h-[6px] flex-1 rounded-full transition ${idx === index ? 'bg-white' : 'bg-white/40'}`}
          />
        ))}
      </div>
    </div>
  );
}
